import React, { useEffect, useState } from "react";
import { Avatar, Badge, Group, Text } from "@mantine/core";
import _ from "lodash";
import { useServerApi } from "../hooks/userServerApi";
import { useFormatter } from "../hooks/useFomatter";

const isPopulatedUser = (user) =>
  user &&
  typeof user === "object" &&
  (user.name || user.staffId || user.aliasName || user.cname);

const getUserId = (user) => {
  if (!user) return null;
  if (typeof user === "string") return user;
  return user._id ?? null;
};

const UserContent = ({ user, showStaffId = true }) => {
  const [formatter] = useFormatter();

  const getStatusColor = (status) => {
    switch (status) {
      case "INACTIVE":
        return "orange";
      case "TERMINATED":
        return "red";
      default:
        return "cyan";
    }
  };

  return (
    <Group noWrap spacing="xs">
      <Avatar
        alt={user.name}
        src={
          _.isEmpty(user.image)
            ? null
            : `${process.env.REACT_APP_FILE_URL}/${user?.image}`
        }
        radius="xl"
        size="sm"
      >
        {formatter.nameInitial(user)}
      </Avatar>
      <Group spacing="xs" noWrap sx={{ minWidth: 0, flex: 1 }}>
        {showStaffId && user.staffId && (
          <Badge
            size="xs"
            p={0}
            radius={0}
            w={50}
            color={getStatusColor(user.status)}
          >
            {user.staffId}
          </Badge>
        )}
        <Text lineClamp={1} size="sm" weight={600}>
          {formatter.friendlyName(user) || user.name || user.cname || "-"}
        </Text>
      </Group>
    </Group>
  );
};

export default function UserRefDisplay({ userRef, showStaffId = true }) {
  const [api] = useServerApi();
  const userId = getUserId(userRef);
  const [user, setUser] = useState(() =>
    isPopulatedUser(userRef) ? userRef : null,
  );

  useEffect(() => {
    if (isPopulatedUser(userRef)) {
      setUser(userRef);
      return;
    }

    if (!userId) {
      setUser(null);
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const data = await api.getById({ apiEntity: "user", id: userId });
        if (!cancelled) setUser(data);
      } catch (error) {
        if (!cancelled) setUser(null);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [userId, userRef]);

  if (!userRef) return <>-</>;
  if (!user) return <>-</>;
  return <UserContent user={user} showStaffId={showStaffId} />;
};
